module.exports = __webpack_public_path__ + "img/dbad-picture.866784d3.png";